export default __webpack_public_path__ + "static/media/google-icon.3cec7ff9.svg";